/**
 * `48` — *from {desiredPrevStatusValue} to {desiredNewStatusValue}*. Pairs with trigger `53`;
 * both sides must match, and both come from the trigger's `node_results` like block `45`.
 *
 * Observed inbound fields (`catalog.md` §block census, rawNodes of recipe `61594398` behind
 * automation 62220207): `boardId`, `columnId`, `actualStatusValue`, `prevStatusValue`,
 * `desiredPrevStatusValue`, `desiredNewStatusValue`. The two `desired*` are the configured
 * ones — 14 rows each, `{"index": n, "invalid": false}` — and the rest are wired to the
 * trigger (`actualStatusValue` ← `columnValue`, `prevStatusValue` ← `previousColumnValue`).
 *
 * `desiredPrevStatusValue` names the side monday calls "from", so it is compared with the
 * trigger's **previous** value and `desiredNewStatusValue` with the new one. A transition out
 * of an empty cell has no previous index and therefore matches only `$any$` (`specs/M6-A3`
 * §11 AC 2) — which is `labelValueMatches`' rule, not a special case here.
 */
import { z } from 'zod';
import { defineCondition } from '../block.js';
import { labelValueMatches, labelValueSchema } from '../values.js';
import { NEW_STATUS_OUTPUTS, PREV_STATUS_OUTPUTS, triggerNumberOutput } from './node-results.js';
export const fromToParams = z.object({
    desiredPrevStatusValue: labelValueSchema,
    desiredNewStatusValue: labelValueSchema,
});
export const fromToCondition = defineCondition({
    id: '48',
    kind: 'condition',
    app: 'monday',
    sentencePartial: 'from {something, desiredPrevStatusValue} to {something, desiredNewStatusValue}',
    paramsSchema: fromToParams,
    references: () => [],
    async evaluate(context, params) {
        return (labelValueMatches(params.desiredPrevStatusValue, triggerNumberOutput(context, PREV_STATUS_OUTPUTS)) &&
            labelValueMatches(params.desiredNewStatusValue, triggerNumberOutput(context, NEW_STATUS_OUTPUTS)));
    },
});
//# sourceMappingURL=48.js.map